module.exports = __webpack_public_path__ + "img/c0cc184.png";